import React from "react";
import {withNamespaces} from "react-i18next";

const FormModal = ({t, closeModal, title, component}) => {

    return(
        <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title">{title}</h5>
                <button type="button" className="close" aria-label="Close" onClick={closeModal}>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-body">
                { component }
            </div>
        </div>

    )
};
export default withNamespaces()(FormModal);
